var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 327 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#eb0000;}.cls-2{fill:#524e4d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 307.9,
    y: 3.7,
    width: 6.42,
    height: 31.97
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "282.17 3.7 269.84 35.67 276.58 35.67 285.66 11.3 294.73 35.67 301.47 35.67 289.15 3.7 282.17 3.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "134.81 3.7 122.49 35.67 129.23 35.67 138.3 11.3 147.37 35.67 154.12 35.67 141.79 3.7 134.81 3.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224.05,23.44a6.4,6.4,0,0,1-6.41,6.28,6.15,6.15,0,0,1-6.42-5.86c0-.05,0-.1,0-.14v-20h-6.42v20a12.84,12.84,0,0,0,25.66,0h0v-20H224Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M264.75,13.72a10,10,0,0,0-10-10H240v32h6.32V9.29h7.5a4.44,4.44,0,0,1,.43,8.87,3.08,3.08,0,0,1-.43,0h-5.12l9.33,17.56H265l-6.74-12.58h0A10,10,0,0,0,264.75,13.72Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "187.34 3.7 177.93 16.54 168.52 3.7 160.6 3.7 160.6 3.7 160.6 35.67 167.02 35.67 167.02 12.43 177.93 26.95 188.84 12.43 188.84 35.67 195.26 35.67 195.26 3.7 195.26 3.7 187.34 3.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.48,16.61h-9a3.27,3.27,0,0,1-3.19-3.26,3.21,3.21,0,0,1,3.13-3.26h15.91l3.43-6.37H99.47a9.61,9.61,0,0,0-9.63,9.59h0a9.5,9.5,0,0,0,9.59,9.41h9a3.26,3.26,0,1,1,0,6.52h-16l-3.39,6.39h19.4A9.61,9.61,0,0,0,118.11,26h0a9.49,9.49,0,0,0-9.55-9.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.89,47.51,26.44,78.14A39.92,39.92,0,0,1,40.12.72a39.42,39.42,0,0,1,5.75.42L18.37,28.79a13.76,13.76,0,0,0,0,19.33,13.58,13.58,0,0,0,19.21.06l.06-.06,10-10a6.54,6.54,0,0,1,9.25,0l0,0A6.68,6.68,0,0,1,56.89,47.51ZM53.81,3.13,23.36,33.72a6.71,6.71,0,0,0,0,9.41,6.54,6.54,0,0,0,9.24,0l0,0,10-10a13.59,13.59,0,0,1,19.21-.07l.06.07a13.73,13.73,0,0,1,0,19.32L34.38,80.13a39.92,39.92,0,0,0,19.43-77Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\u30D1\\u30BF\\u30FC\\u30F31"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "292.88 45.63 285.66 56.93 278.44 45.63 271.36 45.63 282.44 61.84 282.44 77.88 288.88 77.88 288.88 61.84 299.96 45.63 292.88 45.63"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 213.18,
    y: 45.63,
    width: 6.25,
    height: 32.25
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "225.51 61.55 237.95 45.63 230.91 45.63 218.25 61.74 230.91 77.88 238.31 77.88 225.51 61.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "195.21 45.63 189.32 45.63 188.76 45.63 176.38 77.88 183.15 77.88 192.26 53.3 201.38 77.88 208.15 77.88 195.77 45.63 195.21 45.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "314.06 45.63 308.17 45.63 307.61 45.63 295.23 77.88 302 77.88 311.11 53.3 320.23 77.88 327 77.88 314.62 45.63 314.06 45.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M172.29,55.74a10.11,10.11,0,0,0-10.11-10.11h-14.7V77.88h6.37V51.27h7.53a4.47,4.47,0,0,1,0,8.94h-5.14l3,5.64h0l6.37,12h6.91l-6.83-12.65a10.1,10.1,0,0,0,6.62-9.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.71,45.63a15.56,15.56,0,0,1,11.39,4.85,16,16,0,0,1,4.73,11.74,15.79,15.79,0,0,1-4.77,11.57,16.31,16.31,0,0,1-23.14-.23,16.43,16.43,0,0,1,11.79-27.93m-.09,5.82a9.85,9.85,0,0,0-7.32,3,10.52,10.52,0,0,0-3,7.67A10,10,0,0,0,249,70.33a10.15,10.15,0,0,0,6.63,2.39,9.68,9.68,0,0,0,7.23-3,11.05,11.05,0,0,0,.05-15.11,9.85,9.85,0,0,0-7.29-3.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "89.87 45.63 89.87 45.64 93.11 51.75 100 51.75 100 77.88 106.45 77.88 106.45 51.75 113.35 51.75 116.58 45.65 116.58 45.63 89.87 45.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "139.55 71.95 128.77 71.95 128.77 64.49 139.1 64.49 139.1 58.9 128.77 58.9 128.77 51.54 139.55 51.54 142.68 45.63 122.49 45.63 122.49 77.86 142.68 77.86 139.55 71.95"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e144e8cb636523e859e1f13de45e46c2.svg";
export { ForwardRef as ReactComponent };